import React from "react";

import { pdf } from "@react-pdf/renderer";

import client from "@/client";
import { graphql } from "@/gql";

import PDFDocuments, { PDFSectionsProp } from "../PDFDocuments";

const pdfDownloadLinkMenuItemQuery = graphql(`
  query PDFDownloadLinkMenuItem($id: ID!) {
    program(id: $id) {
      id
      ...PDFDocuments
      startDate
      endDate
    }
  }
`);

export async function downloadPDF(
  programId: string,
  sections?: Partial<PDFSectionsProp>
) {
  const { data } = await client.query({
    query: pdfDownloadLinkMenuItemQuery,
    variables: { id: programId },
  });
  if (data.program == null) return;

  const fileName = `${data.program.name}_${data.program.startDate}-${data.program.endDate}.pdf`;
  const blob = await pdf(
    <PDFDocuments pdfData={data.program} enabledSections={sections} />
  ).toBlob();
  const link = document.createElement("a");
  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  link.click();
}
